import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilePdf,
  faFilter,
  faTimes,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { Link, withRouter, Redirect } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import SearchBox from "./SearchBox";
import { connect } from "react-redux";
import { apiMiddleware } from "../../services/apis/apiMiddleware";
import { Url } from "../../services/utilities/util";
import Autocomplete from "react-autocomplete";
import { mapKeys } from "lodash";
import Dropdown from "react-bootstrap/Dropdown";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
// import {  } from "react-router-dom";
let keyMapping = {
  markets: "city",
  region: "region",
  macromarkets: "macromarket",
  micromarkets: "micromarket",
  pincodes: "pincode",
  complexes: "complex",
  buildings: "building",
  buildingCategory: "building_category",
  spaceTypes: "spacetype",
  propertyCondition: "property_condition",
  tenants: "tenant",
  sector: "sector",
  developers: "developer",
  landlords: "landlord",
  ownershipType: "ownership_type",
  owners: "owner",
  renewed_lease: "renewed-lease",
  documentType: "document_type",
  creid: "Lease_Id",
  cresaleid: "Sale_Id",
  seller: "seller",
  purchaser: "purchaser",
  redirect: false,
  uri: "",
  endStatus: "end_status",
  brandsParent: "brands_parent",
};
const mapStateToProps = (state) => {
  return {
    showFilterDiv: state.showFilterDiv,
    filters: state.selectedFilters,
  };
};
class Header extends React.Component {
  state = {
    showFilter: false,
    filters: {},
    searchKey: 0,
    searchVal: "",
    searchResult: [],
    menuShow: false,
    searchArr: [],
    showFilterArr: [],
    mountHref: "",
    displayFilters: {},
  };

  handleClick = () => {
    this.props.dispatch({
      type: "SHOW_FILTER_DIV",
      payload: { showFilterDiv: true },
    });
  };

  closePopup = () => {
    this.props.dispatch({
      type: "HIDE_FILTER_DIV",
      payload: { showFilterDiv: false },
    });
  };

  componentDidMount() {
    this.state.displayFilters = this.props.filters;
    this.setState({});
    for (const key in this.state.displayFilters) {
      for (let i = 0; i < this.state.displayFilters[key].length; i++) {
        this.state.showFilterArr.push(this.state.displayFilters[key][i].label);
      }
    }
    var body = new FormData();
    body.append("screener", "edge_office");
    apiMiddleware.post("api/screener/load_filters", body).then((res) => {
      var filters = {};
      for (let filter in res.data) {
        if (typeof res.data[filter]["main_category"] !== "undefined")
          filters[res.data[filter]["main_category"]] = [];
      }

      for (let filter in res.data) {
        if (typeof res.data[filter]["main_category"] !== "undefined")
          filters[res.data[filter]["main_category"]].push(res.data[filter]);
      }

      this.setState({ showFilter: true, filters: filters });
      this.setState({ searchKey: Math.random() });
    });
  }

  componentDidUpdate() {
    if (
      JSON.stringify(this.props.filters) !==
      JSON.stringify(this.state.displayFilters)
    ) {
      this.state.showFilterArr = [];
      this.state.displayFilters = this.props.filters;
      // console.log(this.props.filters);
      this.setState({});
      var size = Object.keys(this.state.displayFilters).length;
      if (size === 0) {
        this.setState({
          showFilterArr: [],
        });
      }
      for (const key in this.state.displayFilters) {
        for (let i = 0; i < this.state.displayFilters[key].length; i++) {
          // console.log(object)
          if (
            this.state.showFilterArr[i] !==
            this.state.displayFilters[key][i].label
          ) {
            this.state.showFilterArr.push(
              this.state.displayFilters[key][i].label
            );
          }
        }
      }
    }
  }

  getSearchResult(e) {
    if (this.state.searchVal !== "") {
      apiMiddleware
        .post(
          `api/screener/search?search_term=${this.state.searchVal}&screener=edge_office`
        )
        .then((res) => {
          this.setState(
            {
              searchResult: res.data.suggestions,
              menuShow: true,
            },
            () => {
              for (let i = 0; i < this.state.searchResult.length; i++) {
                let searchObj = {};
                searchObj["label"] =
                  this.state.searchResult[i].value +
                  " " +
                  this.state.searchResult[i].value;
                this.state.searchArr.push(searchObj);
              }
            }
          );
        });
    } else {
      this.setState({ menuShow: false });
    }
  }

  redirectToResult(val, item) {
    console.log(item);
    if (item.meta.filter_name == "brands_parent") {
      item.meta.filter_name = "brandsParent";
    }
    // console.log(this.props.location.pathname);
    // console.log(item);
    if (item.meta.type == "Micromarket") {
      this.props.location.pathname = "/office/region/";
    } else if (item.meta.type == "Macromarket") {
      this.props.location.pathname = "/office/region/";
    } else if (item.meta.type == "Market") {
      this.props.location.pathname = "/office/region/";
    } else if (
      item.meta.type == "Tenant Parent" ||
      item.meta.type == "Tenant SPV"
    ) {
      this.props.location.pathname = "/office/occupier/";
    } else if (item.meta.type == "Developer") {
      this.props.location.pathname = "/office/developer/";
    } else if (item.meta.type == "Property") {
      this.props.location.pathname = "/office/asset/";
    }
    let url = `{"${keyMapping[item.meta.filter_name]}":[{"id":"${
      item.id
    }","value":"${item.value}","label":"${item.label}"}]}`;
    let url1 = `{"${[item.meta.filter_name]}":[{"id":"${item.id}","value":"${
      item.value
    }","label":"${item.label}"}]}`;
    var uri =
      this.props.location.pathname + "?filter=" + encodeURIComponent(url);
    this.setState({ uri: uri, redirect: true });
    this.props.dispatch({
      type: "CHANGE_SELECTED_FILTER_MENU",
      payload: JSON.parse(url1),
      selectMenu: item.meta.type,
    });

    this.setState({ searchVal: "", menuShow: false });
  }

  removeFilter(deleteObject) {
    // console.log(Url.get.filter);
    let _filters = JSON.parse(Url.get.filter);
    // console.log(deleteObject);
    if (deleteObject.type == "arrayObject") {
      let newArr = _filters[deleteObject.key].findIndex(
        (x) => x.id == deleteObject.id
      );

      _filters[deleteObject.key].splice(newArr, 1);
    } else {
      delete _filters[deleteObject.key];
    }

    var uri =
      this.props.location.pathname +
      "?filter=" +
      encodeURIComponent(JSON.stringify(_filters));
    // console.log(uri);
    this.props.history.push(uri);
    window.location.reload();
  }

  displaySelectedFilters() {
    var counter = 0;
    var tempFilters = [];
    var self = this;
    if (Url.get.filter == undefined) return;
    var currentFilters = JSON.parse(Url.get.filter);
    {
      Object.keys(currentFilters).map((x, i) => {
        if (typeof currentFilters[x][0] === "object") {
          currentFilters[x].map((y) => {
            // console.log(y);
            tempFilters[counter] = y;
            tempFilters[counter]["key"] = x;
            tempFilters[counter]["type"] = "arrayObject";
            counter++;
          });
        } else if (typeof currentFilters[x] === "string") {
          tempFilters[counter] = {};
          tempFilters[counter]["label"] = currentFilters[x];
          tempFilters[counter]["key"] = x;
          tempFilters[counter]["type"] = "string";
          counter++;
        } else if (
          currentFilters[x] == "array" &&
          currentFilters[x].length > 0
        ) {
          tempFilters[counter] = {};
          tempFilters[counter]["label"] = JSON.stringify(currentFilters[x]);
          tempFilters[counter]["key"] = x;
          tempFilters[counter]["type"] = "array";
          counter++;
        }
      });
    }

    return (
      <>
        {tempFilters.slice(0, 3).map((y) => {
          return (
            <>
              <span
                className="selectedFilters selectedFiltersText"
                // title={key}
              >
                {y.label.includes("T1") ? y.label.split("T1")[0] : y.label}
              </span>
              <span
                className="selectedFilters"
                style={{ marginLeft: "0" }}
                onClick={() => {
                  self.removeFilter(y);
                }}
              >
                <FontAwesomeIcon icon={faTimes} />
              </span>
            </>
          );
        })}
        {tempFilters.length > 3 && (
          <span className="selectedFilters totalFiltersSpan">
            {tempFilters.length - 3}
            <ul className="selectedFiltersDropdown">
              {tempFilters.slice(3, tempFilters.length).map(function (key) {
                return (
                  <li>
                    {key.label.includes("T1")
                      ? key.label.split("T1")[0]
                      : key.label}
                    <span
                      style={{ float: "right" }}
                      onClick={() => {
                        self.removeFilter(key);
                      }}
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </span>
                  </li>
                );
              })}
            </ul>
          </span>
        )}
      </>
    );
  }

  getPdf() {
    let fileName = window.location.href.split("office/")[1].replace("/", "");
    if (fileName.includes("?")) {
      fileName = fileName.split("?")[0];
    }
    const input = document.getElementById("root");
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "pt", [canvas.width, canvas.height]);
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHight);
      pdf.save(`${fileName}.pdf`);
    });
  }

  render() {
    if (this.state.redirect === true) {
      this.state.redirect = false;
      // window.location.href = this.state.uri;
      // this.props.history.push(this.state.uri);
      return <Redirect to={this.state.uri} />;
    }
    return (
      <div className="container-fluid header">
        <div className="row">
          <div className="col-lg-1">
            <Link to={"/office/dashboard/"}>
              <img
                alt="CRE Matrix Logo"
                src="/edge/images/cre_edge_logo.png"
                className="creMatrixLogo"
              />
            </Link>
          </div>
          <div
            className="col-lg-9 searchBarContainer"
            ref={(node) => (this.node = node)}
          >
            <Autocomplete
              inputProps={{
                placeholder: "Search Property, Tenant, Landlord, Anything...",
              }}
              getItemValue={(item) => item.label}
              items={this.state.searchResult}
              renderItem={(item, isHighlighted) => (
                <div
                  style={{
                    background: isHighlighted ? "#4c8fea" : "white",
                    padding: "10px",
                    color: isHighlighted ? "#fff" : "#000",
                  }}
                >
                  {item.label}
                  <span style={{ float: "right", fontSize: "12px" }}>
                    {item.meta.type}
                  </span>
                </div>
              )}
              value={this.state.searchVal}
              onChange={(e) => {
                this.setState({ searchVal: e.target.value }, () => {
                  this.getSearchResult(e);
                });
              }}
              onSelect={(val, item) => {
                this.redirectToResult(val, item);
              }}
              open={this.state.menuShow}
            />
            <span className="filterBtn" onClick={this.handleClick}>
              <FontAwesomeIcon icon={faFilter} /> Filters
            </span>
            {this.displaySelectedFilters()}
            {/* {this.state.showFilterArr.slice(0, 3).map(function (key) {
              return (
                <span
                  className="selectedFilters selectedFiltersText"
                  title={key}
                >
                  {key}
                </span>
              );
            })} */}
          </div>
          <div className="col-lg-2 iconContainer">
            <Dropdown>
              <Dropdown.Toggle
                id="dropdown-basic"
                style={{ backgroundColor: "transparent", border: "0" }}
              >
                <FontAwesomeIcon icon={faUser} />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="https://www.crematrix.com/logout?redirect=/">
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <FontAwesomeIcon
              icon={faFilePdf}
              onClick={(e) => {
                this.getPdf();
              }}
            />
          </div>
          {this.props.showFilterDiv && this.state.searchKey !== 0 && (
            <div className="col-lg-12">
              <SearchBox
                onChange={this.closePopup}
                filtersGroup={this.state.filters}
                showFilter={this.state.showFilter}
                key={this.state.searchKey}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, null)(Header));
